import { useNavigate } from 'react-router-dom';
import { NavMenuItemType } from '../../../model/NavMenu.model';
import informationConfig from '../../../shared-content/inputDescription';
import { withErrorBoundary } from "../../../shared-components/ErrorBoundary";
import '../spa-styles.css';
import { CampaignHeader } from "./EditCamapaignHeader";
import { EditCampaignTabs } from './EditCampaignTabs';
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch, RootState } from "../../../root-redux/RootState"
import { InformationText } from '../../../shared-components/info-text/InformationText';
import { Button, Dialog, InlineStatus, ProgressRing } from '../SpaAdminScope';
import { getCampaignById, postCampaignDetails } from '../../../services/SPAAdmin/CampaignById.api';
import { useCallback, useEffect, useState } from 'react';
import { setCampaignSummary, setShowApprovedByLoading } from '../redux/CampaignById.redux';
import { taxonomySelector } from '../redux/Taxonomy.selector.redux';
import { ConfigRenderer, RenderMandatoryFields, validateField } from './Components/ConfigRenderer';
import { UserMode } from '../redux/CacheHandler.redux';
import { Helper } from '../utils/Help';
import { Environment, Release } from '../../../model/releases/Release.model';
import { v4 as uuidv4 } from 'uuid';
import { postRelease } from '../../../services/PostRelease.api';
import { CAMPAIGN_APPROVED_BY_FIELD, CAMPAIGN_TARGETED_PIPELINE_FIELD, CampaignTypesEnum, QueryBuilderFields, SPA_CAMPAIGN_TYPE_ATTRIBUTE, SPA_SubscriptionKey } from '../SPAConstants';
import { RequestStatus } from '../../../model/ServiceRequestStatus.model';
import '../../edit-workflow/edit-workflow-styles.css';
import '../spa-styles.css';
import { getApproverObjectByIdOrName } from '../../../services/SPAAdmin/SPAUserObjects.api';
import { isTargetAreaSelectionValid } from './CampaignQueryBuilder.utils';

enum OpenStatus {
    INVALID_ACTIONBYDATE = 1,
    INVALID_EXPIRYDATE = 2,
    INVALID_DATES = 3,
    IS_OPEN_INVALID_APPROVER = 4,
    IS_OPEN_INVALID_TARGETEDPIPELINE = 5
}

const CampaignSummaryC: React.FC = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const [isValid, setIsValid] = useState<boolean>(false);
    const [isOpen, setIsOpen] = useState<number>(0);
    
    const isNavPanelOpen = useSelector((state: RootState) => state.nav.isNavPanelOpen);
    const campaignRules = useSelector((state: RootState) => state.campaignList.campaignRules);
    const campaignConfig = useSelector((state: RootState) => state.campaignConfig);
    const cacheHandler = useSelector((state: RootState) => state.cacheHandler);
    const campaignById = useSelector((state: RootState) => state.campaignById);
    const userDetails = useSelector((state: RootState) => state.userDetails);
    const userSalesRoles = useSelector((state: RootState) => state.userSalesRoles);
    const selectedEnv = useSelector((state: RootState) => state.env.selectedEnvItem);
    const editCampaignFlag = useSelector((state: RootState) => state.campaignById.editCampaignFlag);

    const taxonomyState = useSelector(taxonomySelector);
    const campaignUserObjectsState = useSelector((state: RootState) => state.spaUserObjects);

    const _onNavMenuItemClick = useCallback((navMenuItemType: NavMenuItemType, path: string | undefined = undefined) => {
        navigate("/" + NavMenuItemType[navMenuItemType] + (path ? `/${path}` : ''));
    }, [navigate]);

    const dispatchPostCampaign = async () => {

        //Create release for New campaign and New version of an existing campaign
        var createRelease:boolean = campaignById?.campaign && !editCampaignFlag?false:true; 
        dispatch(postCampaignDetails()).unwrap().then((result) => {
            if(result) {
                if(createRelease) {
                    const environments: Environment[] = [
                        { environment: "dev", isDeployed: true },  { environment: "uat", isDeployed: false },  { environment: "prod", isDeployed: false }];
                    
                    const releaseData : Release = {
                        environments: environments,
                        timestamp: "",
                        releaseId: uuidv4().toString(),
                        workflowId: result.config.workflowId??'',
                        version: result.version?.toString() ?? "1",
                        id: uuidv4().toString(),
                        type: "New Version",
                        status: "New",
                        scheduleCreated: false,
                      };
                      dispatch(postRelease({payload : releaseData, env: selectedEnv}));
                }
                _onNavMenuItemClick(NavMenuItemType.Campaign, "refine");
            }
        });

    }

    // When Campaign being edited, we need to pull the username based on user objectid
    // useEffect(() => {

    //     if (campaignById && campaignById.summary[CAMPAIGN_APPROVED_BY_FIELD] && campaignById.summary[CAMPAIGN_APPROVED_BY_FIELD].length > 0)
    //     {
    //         setShowApprovedByLoading(true);
    //             const approvedBy = campaignById.summary[CAMPAIGN_APPROVED_BY_FIELD];
    //             dispatch(getApproverObjectByIdOrName(approvedBy)).unwrap().then((result) => {
    //                 if (result && result[0] && result[0].id) {
    //                     dispatch(setCampaignSummary({ key: CAMPAIGN_APPROVED_BY_FIELD, value: result[0].userPrincipalName.substring(0, result[0].userPrincipalName.indexOf("@")) }));
    //                     setShowApprovedByLoading(false);
    //                 }
    //             });
    //     }

    // },[]);
    const onNextClick = async () => {
        if (cacheHandler.campaignCache?.mode === UserMode.EDIT && userDetails.localAccountId !== campaignById.campaign?.createdBy && !userSalesRoles.isSpaAdmin) {
            _onNavMenuItemClick(NavMenuItemType.Campaign, "refine");
            return;
        }
        const today = new Date().getTime();
        const actionByDate = new Date(campaignById.summary['ActionByDate'] || "").getTime() < today;
        const expiryDate = new Date(campaignById.summary['ExpiryDate'] || "").getTime() < today;
        if (actionByDate || expiryDate) {
            setIsOpen(actionByDate && expiryDate ? OpenStatus.INVALID_DATES : 
                                    actionByDate ? OpenStatus.INVALID_ACTIONBYDATE : OpenStatus.INVALID_EXPIRYDATE);
            return;
        }
        
        //Check for Targeted Pipeline validation based on campaign type.
        //Should be >=1 million for SMC and >= 100 million for Enterprise
        // if (campaignById.summary[CAMPAIGN_TARGETED_PIPELINE_FIELD] && campaignById.summary[CAMPAIGN_TARGETED_PIPELINE_FIELD] !== "") {
        //     const pipelineValue = parseFloat(campaignById.summary[CAMPAIGN_TARGETED_PIPELINE_FIELD].replace(/,/g, ''));
        //     if (isNaN(pipelineValue)) {
        //         setIsValid(false);
        //         setIsOpen(OpenStatus.IS_OPEN_INVALID_TARGETEDPIPELINE);
        //         return;
        //     }
        //     if (campaignById.summary[SPA_CAMPAIGN_TYPE_ATTRIBUTE] === CampaignTypesEnum.SMC && pipelineValue < 1000000) {
        //         setIsValid(false);
        //         setIsOpen(OpenStatus.IS_OPEN_INVALID_TARGETEDPIPELINE);
        //         return;
        //     } else if (campaignById.summary[SPA_CAMPAIGN_TYPE_ATTRIBUTE] === CampaignTypesEnum.Enterprise && pipelineValue < 100000000) {
        //         setIsValid(false);
        //         setIsOpen(OpenStatus.IS_OPEN_INVALID_TARGETEDPIPELINE);
        //         return;
        //     }
        // }


        //Check if approver is valid
        // if (campaignById.summary[CAMPAIGN_APPROVED_BY_FIELD] && campaignById.summary[CAMPAIGN_APPROVED_BY_FIELD].length > 0) {
        //     let approvedBy = campaignById.summary[CAMPAIGN_APPROVED_BY_FIELD];
        //     approvedBy = approvedBy.endsWith("@microsoft.com") ? approvedBy : approvedBy.concat("@microsoft.com");
        //     setShowApprovedByLoading(true);
        //     dispatch(getApproverObjectByIdOrName(approvedBy)).unwrap().then((result) => {
        //         if (result && result[0] && result[0].id) { 
        //             dispatch(setCampaignSummary({ key: CAMPAIGN_APPROVED_BY_FIELD, value: result[0].id }));
        //             dispatchPostCampaign();
        //         } else {
        //             setIsValid(false);
        //             setIsOpen(OpenStatus.IS_OPEN_INVALID_APPROVER);
        //             return;
        //         }
        //         setShowApprovedByLoading(false);
        //     }).catch((error) => {
        //         setIsValid(false);
        //         setIsOpen(OpenStatus.IS_OPEN_INVALID_APPROVER);
        //         setShowApprovedByLoading(false);
        //         return;
        //     })

        // }
        // else {
            dispatchPostCampaign();
       // }
        
    };

    const handleSummaryFormChange = (e: any) => {
        if (e.target.tagName && e.target.tagName.toUpperCase().search("DATE-PICKER") !== -1) {
            if(e.target.value && e.target.value.length > 0) {
            const darr = e.target.value.split('-');
            const value = `${darr[1]}/${darr[2]}/${darr[0]}`;
            dispatch(setCampaignSummary({ key: e.target.name, value: value}));
            }else{
                dispatch(setCampaignSummary({ key: e.target.name, value: "" })); //Empty value applies when datepicker is cleared
            }
        } 
        else if (e.target.tagName && e.target.tagName.toUpperCase().search("CHECKBOX") !== -1) {
            const value = e.target.checked ? "true" : "false";
            dispatch(setCampaignSummary({ key: e.target.name, value: value}));
        }
        else if (e.target.name !== "SubscriptionKey") {
            const keyName = e.target.name;
            let value = (e.target.value || "").trim();
            value = value.replaceAll(new RegExp("\\$","g"),"$$$$"); //replace $ with $$ for escape character
            value = value.replaceAll("'", "\\\\'");
            value = value.replaceAll('\\r', '\n').replaceAll('\\n', '\n').replaceAll('\\r\\n', '\n');
            value = value.split('\n').map((str: string) => str.trim()).filter((str: string) => str.length > 0 || keyName === 'RecommendationTitle').join('\n').replaceAll('\n', '\\\\\\\\r\\\\\\\\n');
            dispatch(setCampaignSummary({ key: keyName, value: value }));
            const field = campaignConfig.campaignConfig?.layoutFields.find(lf => lf.name === keyName)?.taxonomyField;
            campaignConfig.campaignConfig?.layoutFields.filter(lf => lf.taxonomyFilterKey?.includes(field!)).forEach(lf => {
                dispatch(setCampaignSummary({ key: lf.name, value: "" }));
            });
            if (keyName === QueryBuilderFields.SolutionArea) {
                dispatch(setCampaignSummary({ key: QueryBuilderFields.Product, value: "" }));
            }
        }
        return true;
    }

    if (cacheHandler.campaignCache?.mode === UserMode.EDIT && cacheHandler.campaignCache?.campaignId === undefined) {
        _onNavMenuItemClick(NavMenuItemType.Configuration);
    } else if (cacheHandler.campaignCache?.mode !== UserMode.CREATE && campaignById.requestStatus === RequestStatus.idle && cacheHandler.campaignCache?.campaignId !== undefined)
    {
        dispatch(getCampaignById(cacheHandler.campaignCache?.campaignId!));
    }

    useEffect(() => {
        let isValid = true;
        for(const layoutField of (campaignConfig.campaignConfig?.layoutFields || [])) 
        {
            if (layoutField.required === true && !validateField(layoutField.regex, campaignById.summary[layoutField.name]) ) {
                isValid = false;
                break;
            }
        }
        if (campaignById.summary["Resurface"] === "true" && (campaignById.summary["ByPassCoolDownLogicJustification"] || "").length === 0) {
            isValid = false;
        }
        if (!isTargetAreaSelectionValid(campaignById.summary)) {
            isValid = false;
        }
        setIsValid(isValid);
    }, [campaignConfig, campaignById.summary, cacheHandler]);

    useEffect(() => {
        if (Helper.isEmpty(campaignById.summary)) {
            dispatch(setCampaignSummary({ key: "CampaignType", value: CampaignTypesEnum.SMC }));
            dispatch(setCampaignSummary({ key: "SubscriptionKey", value: SPA_SubscriptionKey }));
            dispatch(setCampaignSummary({ key: "CreatedOn", value: Helper.getCurrentDatetime() }));
            dispatch(setCampaignSummary({ key: "Resurface", value: "false" }));
        }
    }, [campaignById.summary]);

    return (
        <>
            
            <div className={`spa-sticky-header ${isNavPanelOpen ? '': 'collapsed'}`}>
                <CampaignHeader title={campaignById?.summary?.CampaignName ?? "Summary"} currentPage={1}  workflowName=""/>
                
                <div className='spa-workspace'>
                    <EditCampaignTabs stage={0}/>
                </div>

                <div className="spa-informationtext">
                    <InformationText text={informationConfig.campaignSummary} type="Heading"/>
                </div>
            </div>

            <div className='workflows-wrapper' style={{marginTop: "180px"}}>

                {Helper.notReadyStatus(campaignConfig.requestStatus, taxonomyState.status) ||campaignById.showApprovedByLoading|| (cacheHandler.campaignCache?.mode === UserMode.EDIT && Helper.isLoadingStatus(campaignById.requestStatus)) ?
                    <div className='spa-progressring'>
                        <ProgressRing label="Loading..." indeterminate></ProgressRing>
                    </div>
                :
                    <>
                        <table className='workflow-form-table  workflow-basics-table' role='presentation' style={{marginBottom: '80px'}}>
                            <RenderMandatoryFields selectionChange={handleSummaryFormChange} layoutConfigs={campaignConfig.campaignConfig?.layoutFields} summary={campaignById.summary} editCampaignFlag={editCampaignFlag} />
                            <ConfigRenderer section={2} summary={campaignById.summary} layoutConfigs={campaignConfig.campaignConfig?.layoutFields} selectionChange={handleSummaryFormChange} taxonomyState={taxonomyState} editCampaignFlag={editCampaignFlag} campaignRules={campaignRules} campaignUserObjectsState={campaignUserObjectsState}/>
                        </table>
                    </>
                }
                <div className={`workflow-footer ${isNavPanelOpen ? '': 'collapsed'}`}>
                    <Button type='button' appearance='secondary' onClick={() => _onNavMenuItemClick(NavMenuItemType.Configuration)} style={{ marginRight: '20px' }}>Previous</Button>
                    <Button type='button' appearance='primary' onClick={onNextClick} disabled={!isValid || Helper.isLoadingStatus(campaignById.requestStatus)}>Next</Button> 
                    {Helper.isLoadingStatus(campaignById.requestStatus) && <ProgressRing indeterminate style={{marginTop: "1px", marginLeft: "20px"}}></ProgressRing>}
                </div>
            </div>

            <Dialog heading="Invalid Dates" open={isOpen > 0 && isOpen < OpenStatus.IS_OPEN_INVALID_APPROVER} onHeAfterHide={() => setIsOpen(0)}>
                <InlineStatus type="error">
                    {isOpen === OpenStatus.INVALID_ACTIONBYDATE || isOpen === OpenStatus.INVALID_DATES ? <b>Action By Date</b> : ""}
                    {isOpen === OpenStatus.INVALID_DATES ? " and " : ""}
                    {isOpen === OpenStatus.INVALID_EXPIRYDATE || isOpen === OpenStatus.INVALID_EXPIRYDATE ? <b>Expiry Date</b> : ""}
                    {isOpen === OpenStatus.INVALID_DATES ? " are " : " is "} incorrect.</InlineStatus>
                <p>Please select future date !</p>
                <Button slot="footer" onClick={() => setIsOpen(0)}>Ok</Button>
            </Dialog>

            <Dialog heading="Invalid Approver" open={isOpen === OpenStatus.IS_OPEN_INVALID_APPROVER} onHeAfterHide={() => setIsOpen(0)}>
                <InlineStatus type="error">
                    <b>Approver</b>: {campaignById?.summary[CAMPAIGN_APPROVED_BY_FIELD]} is invalid.
                </InlineStatus>
                <p>Please add valid Approver alias for CA to be published to Production.</p>
                <Button slot="footer" onClick={() => setIsOpen(0)}>Ok</Button>
            </Dialog>

            <Dialog heading="Invalid TargetedPipeline" open={isOpen === OpenStatus.IS_OPEN_INVALID_TARGETEDPIPELINE} onHeAfterHide={() => setIsOpen(0)}>
                <InlineStatus type="error">
                    <b><p>Target Pipeline must be greater than $1mn for SMC and $100Mn for Enterprise. </p></b>
                </InlineStatus>
                <Button slot="footer" onClick={() => setIsOpen(0)}>Ok</Button>
            </Dialog>
        </>
    )
}

export const CampaignSummary = withErrorBoundary("New Campaign Summary", CampaignSummaryC);
